export const servicesData = [
    {
        id: 1,
        title: 'Website Design',
    },
    {
        id: 3,
        title: 'Website Development',
    },
    {
        id: 6,
        title: 'Responsive UI',
    },
    {
        id: 7,
        title: 'API Development',
    },
    {
        id: 9,
        title: 'API Documentation',
    },
    {
        id: 11,
        title: 'Payment Integration',
    },
    {
        id: 13,
        title: 'External API Integration',
    },
]